import { priceBookIdFormat } from "@redotech/redo-ids-cockroach";
import {
  PriceBookRowSchema,
  PriceBookStatusSchema,
} from "@redotech/redo-model/price-book/price-book";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const updatePriceBook = unaryRpc({
  name: "updatePriceBook" as const,
  input: z.object({
    priceBookId: priceBookIdFormat.schema,
    name: z.string().min(1),
    description: z.string(),
    status: PriceBookStatusSchema,
  }),
  output: z.object({ priceBook: PriceBookRowSchema }),
});
